// src/components/MovieSidebar.jsx
import React from 'react';
import './MovieSidebar.css';

function MovieSidebar({ movies, onMovieClick }) {
  if (!movies || movies.length === 0) {
    return (
      <div className="movie-sidebar">
        <h3 className="sidebar-title">AI Recommended Movies</h3>
        <p>No similar movies found</p>
      </div>
    );
  }

  const handleMovieClick = (movie) => {
    console.log("Clicked on movie:", movie);
    if (movie && movie.id) {
      onMovieClick(movie);
    }
  };

  return (
    <div className="movie-sidebar">
      <h3 className="sidebar-title">AI Recommended Movies</h3>
      <div className="similar-movies-list">
        {movies.map((movie) => (
          <div
            key={movie.id}
            className="similar-movie"
            onClick={() => handleMovieClick(movie)}
            role="button"
            tabIndex={0}
            aria-label={`View details for ${movie.title}`}
          >
            <img
              src={
                movie.poster_path
                  ? `https://image.tmdb.org/t/p/w92${movie.poster_path}`
                  : '/placeholder-poster.jpg'
              }
              alt={movie.title}
            />
            <div className="similar-movie-info">
              <h3>{movie.title}</h3>
              <p>{movie.release_date ? movie.release_date.substring(0, 4) : 'Unknown'}</p>
              <div className="similarity-score">
                {movie.similarity_score ? `${Math.round(movie.similarity_score * 100)}% match` : ''}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MovieSidebar;